import * as Yup from 'yup';

export const validateSchoolPaymentConfigSchema = Yup.object({
  gradeWiseConfig: Yup.array()
    .of(
      Yup.object({
        grades: Yup.array()
          .of(Yup.string().required('Grade is required'))
          .required('Grades are required'),
        razorpaySubMerchantId: Yup.string().required(
          'Razorpay Sub Merchant ID is required'
        ),
        schoolName: Yup.string().required('School Name is required'),
        schoolAddress: Yup.string().required('School Address is required')
      })
    )
    .required('Grade wise configuration is required'),
  razorpay: Yup.object({
    apiUsername: Yup.string().required('API Username is required'),
    apiPassword: Yup.string().required('API Password is required')
  }).optional(),
  receiptTemplateId: Yup.string().required('Receipt Template Id is required'),
  logoUrl: Yup.string().required('Payment Logo is required')
});
